/*
 * @Description: 使用token登录sml商家后台
 * @Author: ljrong
 * @Date: 2024-06-04 09:43:18
 * @LastEditors: ljrong jinrong.li@beautydata.ai
 * @LastEditTime: 2024-06-04 15:57:56
 */
import { get } from '@/utils/request'
import { useUserStore } from '@/store'
// 数选供应链
const tkradarmUrl = import.meta.env.VITE_APP_API_TKRADAR_URL
export default function useTokenLoginSML() {
  let isSmlUser = false
  const userStore = useUserStore()

  if (userStore.userInfo?.smlBgUserFlag === 1) {
    isSmlUser = true
  }

  async function jumpToSml() {
    try {
      const smlToken = await get<string>({
        url: '/assistant/external/sml/getToken',
      })
      if (smlToken) {
        window.open(`${tkradarmUrl}#/auth?token=${smlToken}`)
      }
    } catch (error) {
      window.$message?.error(error.resultMessage)
    }
  }

  return {
    jumpToSml,
    isSmlUser,
  }
}
